module.exports = __webpack_public_path__ + "img/marie-curie-logo.c99761fc.svg";